import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState,useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../../components';
import * as Yup from 'yup';
import { DateFilter} from '../../../../components';
import { Loader } from "../../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { IoReloadCircleOutline as ResetIcon} from "react-icons/io5";
import ReactSelect from "../../../../components/Select";
import appStore, { activePeriod } from "../../../../store";


// const allExamTimeTable = [
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   } ,
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   }  
// ]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`

const ExamTimeTableAtom = atom<number | null>(null);


export default function UpgradeScore() {
  const [hide,set_hide] = useState<boolean>(true);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_open] = useAtom(openAtom);
  const [active] = useAtom<number | string | null>(ExamTimeTableAtom);
  const aPeriod = appStore.get(activePeriod)?.Id;
  const [selected_level,set_selected_level] = useState<null | string>(null);
  const [selected_examperiod,set_selected_examperiod] = useState<null | string>(null);
  const [selected_examsubject,set_selected_examsubject] = useState<null | string>(null);
  const [selected_subject,set_selected_subject] = useState<null | string>(null);

  const {data:allExamPeriod} = useQuery(['exam-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
     
      return data.data.Data;
    },
  });

  const {data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allLevel} = useQuery(['exemption'],{
    queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allstudentScore, isLoading} = useQuery<any>(['Student-score'+selected_examperiod+selected_level],{
    queryFn:async()=>await apiCall().get(`Exam/GetAllStudentScore?ExamPeriodId=${selected_examperiod}&SubjectId=${selected_subject ||''}&LevelId=${selected_level || ''}`,{
      }),
    enabled:Boolean(selected_examperiod || selected_subject || selected_level),
    select(data){
    return data.data.reportItems;
    }
  });
  // const {data:allStudentScore, isLoading} = useQuery(['student-score'],{
  //   queryFn:async()=>await apiCall().get(`/exam/GetAllStudentScore?PageNumber=1&PageSize=100`),
  //   select(data){
  //    // console.log(data,'data')
  //   return data.data.reportItems;
  //   }
  // });
  
  const [search,set_search] = useState('');
  const [filter_data,set_filter_data] = useState<any>(allLevel);


  const handleSearch = (e:any)=>{
    let val = e.target.value;
    //console.log(val,'input value')
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).map((eData:any)=> typeof eData === 'object' && eData !== null && !Array.isArray(eData)?JSON.stringify(eData):eData).join().toLowerCase().includes(val.toLowerCase()) );
      console.log(new_data.length,'data length')
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(allstudentScore)
    }
    else set_filter_data(allstudentScore)
  }

  // const handleDateFilter = (obj:any) =>{
  //   const {start,end} = obj; 
  //   console.log(obj,'start end');
  //   const s_date:number = new Date(start.concat("T00:00:00") || null)?.getTime();
  //   const e_date:number = new Date(end.concat("T00:00:00") || null)?.getTime();
  //   console.log(s_date,e_date,'date in seconds')
  //   const tempData:any = allStudentScore;
  //   let f_data = tempData.filter((eData:any)=>{
  //     let e_date_time:number = new Date(eData?.ExamDateTime?.split('.')[0] || null)?.getTime();
  //     console.log(e_date_time,'time in seconds')
  //     return e_date_time >= s_date && e_date_time <= e_date;
  //   })
  //   //console.log(f_data,'date filtered data')
  //   if(f_data.length > 0)set_filter_data(f_data);
  //   else set_filter_data(allStudentScore);
  // }

  useEffect(()=>{
    set_filter_data(allstudentScore)
  },[allstudentScore])
  
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  const handleFilter2=(str:string) =>{
    if(str){
      set_selected_examsubject(str);
      let check:any = allstudentScore.filter((e:any) => e.Subject == str);
      if(check && check?.length > 0){
        set_filter_data(check)
      }
    }
  }

  const handleFilter3 = (e: any, type: string) => {
    const value = type === 'level' ? Number(e || 0) : e;
  
    if (type === 'level') {
      if (value || !isNaN(value)) {
        let data = allstudentScore?.filter((eData: any) => {
          return eData.Level?.Id == value;
        });
  
        if (selected_examperiod) {
          data = data?.filter((eData: any) => eData.ExamPeriod == selected_examperiod);
        }
  
        set_filter_data(data && data.length > 0 ? data : allstudentScore);
        set_selected_level(value);
      }
    } else if (type === 'period') {
      if (value) {
        set_selected_examperiod(value); 
        let check: any = allstudentScore.filter((e: any) => e.ExamPeriod == value);
        set_filter_data(check && check?.length > 0 ? check : allstudentScore);
      }
    } else {
      
      let filteredData = allstudentScore;
  
      if (selected_examperiod) {
        filteredData = filteredData.filter(
          (e: any) => e.ExamPeriod == selected_examperiod
        );
      }
  
      set_filter_data(filteredData);
    }
  };

  const handleChangePeriod = (value: any) => {
    if (value) {
      set_selected_examperiod(value?.Id.toString());
  
      if (Array.isArray(allstudentScore)) {
        const periodFilteredData = allstudentScore.filter((eData: any) => eData.ExamPeriod === value.ExamName);
  
        if (search) {
          //console.log(search,'search')
          const new_data = periodFilteredData?.filter((eData: any) => {
            const studentNoMatches = eData.StudentNo?.toString().toLowerCase().includes(search.toLowerCase());
            const nameMatches = (eData.FirstName + " " + eData.LastName)?.toLowerCase().includes(search.toLowerCase());
  
            return studentNoMatches || nameMatches;
          });
  
          set_filter_data(new_data.length > 0 ? new_data : []);
        } else {
          //console.log('skip search ressult')
          set_filter_data([periodFilteredData]);  // If no search input, clear data for the selected period
        }
      }
    }
  };

  const handleAddUpgradeScore = () =>{
    set_modal({
      header:'Upgrade Subject Score',
      content:<AddType />
    })
    set_open(true);
  }
  useEffect(()=>{},[])

  const handleFilter = (value:string = '') =>{
    if(value){
       let data = allstudentScore?.filter((eData:any) => {
        //console.log(eData.Level,'Level')
        return eData.ExamPeriod == value});
      set_filter_data(data && data.length > 0 ?data : allstudentScore)
    }
    else{
      set_filter_data(allstudentScore) 
    }

  } 
  
  useEffect(()=>{
    if(selected_level){
      let data = allLevel.filter((eData:any) => eData.Status === selected_level);
      if(data.length > 0){
        set_filter_data(data);
      }
    }
    else{
      set_filter_data(allLevel);
    }
  },[selected_level])

  useEffect(()=>{
    //console.log(filter_data,'filter data')
  },[filter_data])

  return (
    <>
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Upgrade Subject Score" button_array={[
          <Button onClick={handleAddUpgradeScore} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Upgrade Subject scores</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <ReactSelect 
              name="ExamName"
              onChange={handleChangePeriod}
              placeholder="Exam Period"
              options={allExamPeriod?.map((e: any) => ({ ...e, ['label']: e.ExamName, ['value']: e.Id }))}
            /> 
          <Select placeholder="Level" width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)"onChange={(e:any)=>handleFilter3(e.target.value,'level')} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
            <Select placeholder='Exam Subject' width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)" onChange={(e:any)=>handleFilter2(e.target.value)}
                  name="ExamSubjectId"
                >
                  <>{allExamSubject && allExamSubject.length > 0 ?
                    allExamSubject.map((eType:any) => <option key={eType.Id} value={eType.Name}>{eType.Name}</option>)
                  :''}</>
                </Select>
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ?  <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
            <Tr >
                <Th sx={HeadStyle}>First Name</Th>
                {/* <Th sx={HeadStyle}>Middle Name</Th> */}
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Subject</Th>
                <Th sx={HeadStyle}>Exam Period</Th>
                <Th sx={HeadStyle}>Exm Level</Th>
                <Th sx={HeadStyle}>Score</Th>
                <Th sx={HeadStyle}>Cut-Off</Th>
                <Th sx={HeadStyle}>Grade</Th>
                <Th sx={HeadStyle}>Exam Status</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eUpgradeScore:any,index:number) =><ROWSTYLE key={index}>
                <Td sx={DataStyle}>{eUpgradeScore.FirstName ||'N/A'}</Td>
                {/* <Td sx={DataStyle}>{eUpgradeScore.MiddleName ||'N/A'}</Td> */}
                <Td sx={DataStyle}>{eUpgradeScore.LastName ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Subject ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.ExamPeriod ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Level ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Score ||'N/A'}</Td>
                <Td sx={DataStyle}>{typeof eUpgradeScore.CutOffMark == 'undefined'?'N/A':eUpgradeScore?.CutOffMark}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Grade ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.ExamStatus||'N/A'}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Subject score'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
    }
    </>
    
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const AddSchema = Yup.object({
  ExamSubjectId:Yup.number().required(),
  ExamPeriodId:Yup.number().required(),
  LevelId:Yup.number().required(),
  upgradeCutOffScore:Yup.number(),
});

const Label = styled.label``;  

const AddType = (props:any) =>{
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);

  const {data:allExamPeriod} = useQuery(['exam-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
      return data.data.Data;
    },
  })
   const {data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allLevel} = useQuery(['exemption'],{
    queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
    select(data){
      return data.data.Data;
    },
  })


  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:['new-grade-upgrade'],
    mutationFn:async (data:any)=> {
      return await apiCall().post(`/exam/grade/upgrade?${data}`,{})},
    onSuccess:(data:any)=>{
      console.log(data,'new data')
      set_notification({
        type:'success',
        message: data?.Message ||data?.data?.Message || 'Scores Upgraded Successfully'
      })
      set_Nopen(true);
      queryClient.invalidateQueries({
        queryKey:['student-score']
      });
    },
    onError(error:any){
      set_notification({
        type:'error',
        message:error?.Message || error?.data?.Message || 'ooops! Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }
  })

  return (
    <Formik
          initialValues={{
            ExamSubjectId:props.ExamSubjectId || '',
            ExamPeriodId:props.ExamPeriodId || '',
            LevelId:props.LevelId || '',
            upgradeCutOffScore: props.upgradeCutOffScore || '',
          }}
          validationSchema={AddSchema}
          onSubmit={(values:any) => {
            console.log('clicked')
            const data: string= `ExamSubjectId=${values.ExamSubjectId}&ExamPeriodId=${values.ExamPeriodId}&upgradeCutOffScore=${values.upgradeCutOffScore}`;
            //  if (props?.Id){data.Id = props.Id;
            //   data.upgradeCutOffScore=values.upgradeCutOffScore
            // } 
            // else  data.upgradeCutOffScore=values.upgradeCutOffScore

            addUpdate(data);
          }}
        >
        {(formik: any) => {
      const { errors, values, touched, setFieldValue } = formik;

      // Filter subjects by selected level
      const filteredSubjects =
        values.LevelId && allExamSubject
          ? allExamSubject.filter((subject: any) => subject.LevelId === values.LevelId)
          : [];
          
        return (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">
              <Field as={Select}
                  bg='var(--white-color)'
                  borderColor='var(--dark-green-color)'
                  color='var(--dark-green-color)'
                  placeholder='Exam Period'
                  name="ExamPeriodId"
                >
                 {allExamPeriod && allExamPeriod.length > 0 ?
                    allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>)
                  :'0'}
                </Field>
                <Field
              as={Select}
              name="LevelId"
              borderColor="green"
              placeholder="Select Level"
              onChange={(e: any) => {
                setFieldValue("LevelId", e.target.value);
                setFieldValue("ExamSubjectId", ''); // Reset ExamSubjectId when level changes
              }}
            >
              {allLevel && allLevel.length > 0
                ? allLevel.map((level: any) => (
                    <option key={level.Id} value={level.Id}>
                      {level.Name}
                    </option>
                  ))
                : ''}
            </Field>
                <Field as={Select} name="ExamSubjectId" borderColor="green" placeholder="Select Subject">
                {values.LevelId && allExamSubject.length > 0 ? (
                  allExamSubject
                    .filter((subject: any) => subject.LevelId == Number(values.LevelId))
                    .map((subject: any) => (
                      <option key={subject.Id} value={subject.Id}>
                        {subject.Name}
                      </option>
                    ))
                ) : (
                  <option value="">No subjects available for this level</option>
                )}
              </Field>
                 {/* <Field as={Select}
                  bg='var(--white-color)'
                  borderColor='var(--dark-green-color)'
                  color='var(--dark-green-color)'
                  placeholder='Exam Subject'
                  name="ExamSubjectId"
                >
                  <>{allExamSubject && allExamSubject.length > 0 ?
                    allExamSubject.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :'0'}</>
                </Field> */}
                <Field as={Input}
                    placeholder="Upgrade CutOff Score"
                    size="md"
                    borderColor='var(--dark-green-color)'

                    name="upgradeCutOffScore"
                    type="number"
                  />  
                
                <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)" >
                  {isLoading?"Loading":'Upgrade'}
                </Button>
              </Flex>
                
              
            </Form>
          )}}
        </Formik>
  )

}

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  // console.log(data,'data')
  const [active,set_active] = useAtom(ExamTimeTableAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const queryClient = useQueryClient();
  

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Scores',
      content:<Grid>
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>First Name</span>
          <span>{data?.FirstName}</span>
        </GridItem >
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Middle Name</span>
          <span>{data?.MiddleName|| 'N/A'}</span>
        </GridItem >
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Score</span>
          <span>{data?.Score ||'N/A'}</span>
        </GridItem >
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Grade</span>
          <span>{data?.Grade}</span>
        </GridItem >
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Subject</span>
          <span>{data?.Subject||'N/A'}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Exam Period</span>
          <span>{data?.ExamPeriod}</span>
        </GridItem>
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Exam Status</span>
          <span>{data?.ExamStatus}</span>
        </GridItem >
      </Grid>
    })
    set_open(true);
    handleClick();
  }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View Details',click:handleView},
      // {label:'Edit ',click:handleEdit},
      // {label:'Delete ',click:handleDelete}
    ]} />
  )
}

